module.exports = __webpack_public_path__ + "img/9C.8f64dcbe.png";